import RegistrationPageCN from "./RegistrationPageCN";
export default RegistrationPageCN